import styled from 'styled-components';

export const ConfirmationsPerHour = styled.span`
    font-size: 25px;
    color: ${({ color }) => color};
    align-self: flex-end;
    margin-bottom: 2px;
    margin-left: 5px;
`;

export const MainWrapper = styled.div`
    height: 300px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-evenly;
`;